const AiIcon = ({ width = 25, height = 25 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      width={width}
      height={height}
      viewBox="0 0 6.827 6.827"
      style={{
        shapeRendering: "geometricPrecision",
        textRendering: "geometricPrecision",
        imageRendering: "optimizeQuality",
        fillRule: "evenodd",
        clipRule: "evenodd",
      }}
    >
      <defs>
        <style>
          {`
            .fil1 { fill: #fffffe; fill-rule: nonzero; }
            .fil2 { fill: #fffffe; }
          `}
        </style>
      </defs>

      <rect
        width="6.827"
        height="6.827"
        rx=".853"
        ry=".853"
        fill="#8bc34a"
      />

      <g>
        <path
          className="fil1"
          d="M5.182 2.541c.17.074.315.204.419.37.105.168.168.373.17.594H4.68c.008-.032.017-.065.027-.097.028-.1.061-.206.102-.303.03-.068.066-.133.105-.196.045-.07.093-.138.143-.204l.12-.158z"
        />
        <path
          className="fil1"
          d="M3.196 3.634h2.777v.207H3.196z"
        />
        <path
          className="fil2"
          d="M5.594 3.81h.212v1.291h-.212z"
        />
        <path
          className="fil1"
          d="M1.805 4.218a.708.708 0 0 1-.214-.52c0-.034 0-.069-.002-.103-.002-.255.081-.422.211-.528.127-.103.294-.141.468-.145h.015c.17.006.332.044.457.145.13.106.213.273.21.528a5.183 5.183 0 0 1-.005.17.709.709 0 0 1-.204.459c-.309.051-.719.058-.936-.006z"
        />
        <path
          className="fil2"
          d="M1.006 5.013h2.528c.084 0 .153.067.153.149v.811H.853v-.811c0-.082.07-.149.153-.149z"
        />
      </g>
    </svg>
  );
};

export default AiIcon;
